export default "__VITE_PUBLIC_ASSET__5319aed1__"